import axios from '../http.js'; //导入http中创建的axios实例
import base from '../base.js'


const common = {
  getTp(params) {//获取租户平台
    return axios.get(`get/tp?key=${params.key}`)
  },
  associatQuestion(params) {//联想问题
    return axios.post(`robot/suggest`, params)
  },
  findAllSettings(params) {//查询全部
    return axios.get(`dialog/all?channel=${params.channel}`, params)
  },
  ask(params) {//机器人问答
    return axios.post(`robot/deliver`, params)
  },
  addHistory(params) {//添加人工聊天消息
    return axios.post(`chat/add`, params)
  },
 
  getHistoryMsg(params) {//历史记录
    return axios.get(`chat/get_chat_all?createTime=${params.createTime}&pageSize=${params.pageSize}&userId=${params.userId}&channel=${params.channel}`, params)
  },
  openSession(params) {//和坐席建立连接ws
    return axios.post(`${base.wsBaseUrl}/track/open_session`, params)
  },
  sendImgMsg(params) {//发送图片
    return axios.post(`${base.wsBaseUrl}/api/message/image?accessId=${params.accessId}&visitorId=${params.visitorId}&userId=${params.userId}`, params.image)
  },
  sendFileMsg(params) {//发送文件
    return axios.post(`${base.wsBaseUrl}/api/message/file?accessId=${params.accessId}&visitorId=${params.visitorId}&userId=${params.userId}`, params.file)
  },
  getSatisfaction(params) {//满意度参数获取
    return axios.get(`${base.wsBaseUrl}/api/setting?accessId=${params.accessId}&language=zh_CN`)
  },
  getSettingsData(params) {//获取满意度参数or留言参数
    return axios.get(`${base.wsBaseUrl}/api/setting?accessId=${params.accessId}&language=zh_CN`)
  },
  getWsChannel(params) {//获取坐席渠道列表
    return axios.get(`${base.wsUrl}/openapi/chat/web/list?tenantId=${params.tenantId}&timestamp=${params.timestamp}&sign=${params.sign}`)
  },
  leaveMsg(params) {//留言
    return axios.post(`${base.wsUrl}/openapi/chat/web/leave_message`, params)
  },
  aiCreate(params) {//大模型新建会话
    return axios.post(`/ai/create`, params)
  },
  aiSearch(params) {//搜索会话
    return axios.get(`/ai/searchChat?userCode=${params.userCode}&sessionName=${params.sessionName}&channel=${params.channel}`)
  },
  aiOperateChat(params) {
    return axios.post(`/ai/operateChat`, params)
  },
  aiDelBatchChat(params) {
    return axios.post(`/ai/delBatchChat?idList=${params.idList}&userCode=${params.userCode}`)
  },
  searchQa(chatId,userCode) {  //会话详情
    return axios.get(`/ai/searchQa?chatId=${chatId}&userCode=${userCode}`)
  },
  saveFeedback(params) {  //点赞点踩
    return axios.post(`/ai/saveFeedback`, params)
  },
  askLimit(params) {  //问答此时限制
    return axios.post(`/ai/askLimit?channel=${params}`)
  },
  authSSO(token, type) {
    return axios.get(`auth/sso?token=${token}&type=${type}`)
  }
}
export default common 